import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";

export default function ChapterPlanDialog({ value, onChange, onSave, onClose }) {
  return (
    <Dialog open={!!value} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="font-serif-display text-2xl">
            {value?.chapterId ? "Modifier le chapitre" : "Ajouter un chapitre au programme"}
          </DialogTitle>
        </DialogHeader>
        {value && (
          <div className="space-y-3">
            <div>
              <label className="eyebrow block mb-1">Titre du chapitre</label>
              <input
                type="text"
                value={value.title}
                onChange={(e) => onChange((s) => ({ ...s, title: e.target.value }))}
                placeholder="Ex. Fractions et décimaux"
                className="w-full px-4 py-3 bg-white border border-[var(--parchment-2)] focus:border-[var(--maroon)] outline-none"
                data-testid="chapter-plan-title-input"
              />
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="eyebrow block mb-1">Date de début prévue</label>
                <input
                  type="date"
                  value={value.start}
                  onChange={(e) => onChange((s) => ({ ...s, start: e.target.value }))}
                  className="w-full px-4 py-3 bg-white border border-[var(--parchment-2)] focus:border-[var(--maroon)] outline-none font-mono-spec"
                  data-testid="chapter-plan-start-input"
                />
              </div>
              <div>
                <label className="eyebrow block mb-1">Date de fin prévue</label>
                <input
                  type="date"
                  value={value.end}
                  onChange={(e) => onChange((s) => ({ ...s, end: e.target.value }))}
                  className="w-full px-4 py-3 bg-white border border-[var(--parchment-2)] focus:border-[var(--maroon)] outline-none font-mono-spec"
                  data-testid="chapter-plan-end-input"
                />
              </div>
            </div>
            <p className="mt-1 text-xs text-[var(--ink-soft)]">La barre de progression compare votre avancement réel à ces dates prévisionnelles. Statuts : À venir · En cours · Terminé · En retard.</p>
          </div>
        )}
        <DialogFooter>
          <button className="btn-secondary" onClick={onClose}>Annuler</button>
          <button className="btn-primary" onClick={onSave} data-testid="chapter-plan-save-btn">Enregistrer</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
